import React from "react";
import NetworkHubMain from "./NetworkHubMain";
import "./networkhub.scss";

const Networkhub: React.FC = () => {
  return <NetworkHubMain />;
};

export default Networkhub;
